import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import filter from "lodash/filter";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  Table,
  Tag,
  Button,
  Modal,
  Breadcrumb,
  Icon,
} from "antd";

import classes from "./SettingsPatientEvents.css";

import isAuthenticated from "../../utils/isAuthenticated";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import SettingsPatientEventForm from "./SettingsPatientEventForm";
import SettingsMilestonesForm from "./SettingsMilestonesForm";
import {
  getEventsManagementList,
  getMilestoneEvents,
} from "../../api/requests";
import {getValidationRequiredStatus} from "../../reducers/user/selectors";

const { Content } = Layout;

class SettingsPatientEvents extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      eventsList: [],
      milestoneEventsList: [],
      errorMessage: "",
      responseMessage: "",
      modalVisible: false,
      modalMilestoneVisible: false,
      editEvent: null,
      editMilestone: null,
      isLoadingMilestones: false,
      isLoading: false,
    };
  }

  async componentDidMount() {
    this.getEventsList();
    this.getMilestoneEventsList();
  }

  getEventsList = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getEventsManagementList();

      this.setState({ eventsList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({ errorMessage: get(e, "response.data.error", "Error") });
    }

    this.setState({ isLoading: false });
  };

  getMilestoneEventsList = async () => {
    this.setState({
      errorMessage: null,
      isLoadingMilestones: true,
    });

    try {
      const { data } = await getMilestoneEvents();

      this.setState({ milestoneEventsList: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({ errorMessage: get(e, "response.data.error", "Error") });
    }

    this.setState({ isLoadingMilestones: false });
  };

  render() {
    const {
      eventsList,
      errorMessage,
      responseMessage,
      isLoading,
      milestoneEventsList,
      isLoadingMilestones,
    } = this.state;
    const {
      validationRequiredStatus
    } = this.props;

    let columns = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t(
          "NamespaceSettingsPatientEvents:Patient Event"
        ),
        render: (val, record) => (
          <div>
            <span className={classes.textMuted}>#{record.order_index}</span>{" "}
            <b>{record.name}</b> &nbsp;{" "}
            {record.show_on_patient_page && (
              <Tag color="#2968ae">{this.props.i18n.t("Shown on page")}</Tag>
            )}
            {record.show_on_patient_page && record.tracking_patient_event && (
              <Tag color="#67bb48">{this.props.i18n.t("Tracking Patient Events")}</Tag>
            )}
            {record.hide_if_pending && record.hide_if_pending && (
              <Tag color="#9e9e9e">{this.props.i18n.t("Hide pending")}</Tag>
            )}
            {record.requires_validation && validationRequiredStatus && (
              <Tag color="#d08f05">{this.props.i18n.t("Requires validation")}</Tag>
            )}
            {record.track_in_finance && (
              <Tag color="#927ee0">{this.props.i18n.t("Track in finance")}</Tag>
            )}
            {record.required_for_completion && (
              <Tag color="#a8324a">{this.props.i18n.t("Required")}</Tag>
            )}
          </div>
        ),
      },
      {
        dataIndex: "actions",
        key: "actions",
        width: 100,
        render: (val, record) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              type="edit"
              theme="filled"
              className={classes.actionIcon}
              onClick={() => {
                this.setState({
                  modalVisible: true,
                  editEvent: record,
                });
              }}
            />
          </div>
        ),
      },
    ];

    let columnsMilestones = [
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("NamespaceSettingsPatientEvents:Milestone"),
        render: (val, record) => (
          <div>
            <div>
              <span className={classes.textMuted}>#{record.order_index}</span>{" "}
              <b>{record.name}</b> &nbsp;{" "}
              {record.show_on_patient_page && (
                <Tag color="#2968ae">{this.props.i18n.t("Shown on page")}</Tag>
              )}
              {record.show_on_patient_page && record.tracking_patient_event && (
                <Tag color="#67bb48">{this.props.i18n.t("Tracking Patient Events")}</Tag>
              )}
              {record.hide_if_pending && record.hide_if_pending && (
                <Tag color="#9e9e9e">{this.props.i18n.t("Hide pending")}</Tag>
              )}
              {record.track_in_finance && (
                <Tag color="#927ee0">{this.props.i18n.t("Track in finance")}</Tag>
              )}
            </div>
            <div style={{ marginTop: "6px" }}>
              <span>Events: &nbsp;</span>
              {map(record.events, ({ name }) => (
                <Tag color="#aaa">{name}</Tag>
              ))}
            </div>
          </div>
        ),
      },
      {
        dataIndex: "actions",
        key: "actions",
        width: 100,
        render: (val, record) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon
              type="edit"
              theme="filled"
              className={classes.actionIcon}
              onClick={() => {
                this.setState({
                  modalMilestoneVisible: true,
                  editMilestone: record,
                });
              }}
            />
          </div>
        ),
      },
    ];

    return (
      <div>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t(
                "NamespaceSettingsPatientEvents:Patient Events"
              )}
            </h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t(
                  "NamespaceSettingsPatientEvents:Patient Events"
                )}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}

            <h5 className="headline">
              {this.props.i18n.t(
                "NamespaceSettingsPatientEvents:Predefined Events"
              )}
            </h5>
            <Table
              columns={columns}
              dataSource={filter(
                eventsList,
                (event) => event.is_predefined
              ).sort((a, b) => a.order_index - b.order_index)}
              loading={isLoading}
              pagination={false}
              rowKey="id"
            />

            <br />
            <br />
            <h5 className="headline">
              {this.props.i18n.t(
                "NamespaceSettingsPatientEvents:Custom Events"
              )}
            </h5>

            <div>
              <Button
                type="primary"
                onClick={() => this.setState({ modalVisible: true })}
                loading={isLoading}
                disabled={isLoading}
              >
                {this.props.i18n.t(
                  "NamespaceSettingsPatientEvents:Add patient event"
                )}
              </Button>
              <br />
              <br />
            </div>

            <Table
              columns={columns}
              dataSource={filter(
                eventsList,
                (event) => !event.is_predefined
              ).sort((a, b) => a.order_index - b.order_index)}
              loading={isLoading}
              pagination={false}
              rowKey="id"
            />

            <br />
            <br />
            <h5 className="headline">
              {this.props.i18n.t("NamespaceSettingsPatientEvents:Milestones")}
            </h5>

            <div>
              <Button
                type="primary"
                onClick={() => this.setState({ modalMilestoneVisible: true })}
                loading={isLoadingMilestones}
                disabled={isLoadingMilestones}
              >
                {this.props.i18n.t(
                  "NamespaceSettingsPatientEvents:Add milestone"
                )}
              </Button>
              <br />
              <br />
            </div>

            <Table
              columns={columnsMilestones}
              dataSource={milestoneEventsList.sort(
                (a, b) => a.order_index - b.order_index
              )}
              loading={isLoadingMilestones}
              pagination={false}
              rowKey="id"
            />

            <Modal
              visible={this.state.modalVisible}
              onCancel={() =>
                this.setState({
                  modalVisible: false,
                  editEvent: null,
                })
              }
              footer={null}
            >
              {this.state.modalVisible && (
                <SettingsPatientEventForm
                  {...this.state.editEvent}
                  onSubmit={() =>
                    this.setState(
                      { modalVisible: false, editEvent: null },
                      this.getEventsList
                    )
                  }
                  isPredefined={
                    this.state.editEvent
                      ? this.state.editEvent.is_predefined
                      : false
                  }
                  onCancel={() =>
                    this.setState({
                      modalVisible: false,
                      editEvent: null,
                    })
                  }
                />
              )}
            </Modal>

            <Modal
              visible={this.state.modalMilestoneVisible}
              onCancel={() =>
                this.setState({
                  modalMilestoneVisible: false,
                  editMilestone: null,
                })
              }
              footer={null}
            >
              {this.state.modalMilestoneVisible && (
                <SettingsMilestonesForm
                  {...this.state.editMilestone}
                  onSubmit={() =>
                    this.setState(
                      { modalMilestoneVisible: false, editMilestone: null },
                      this.getMilestoneEventsList
                    )
                  }
                  onCancel={() =>
                    this.setState({
                      modalMilestoneVisible: false,
                      editMilestone: null,
                    })
                  }
                />
              )}
            </Modal>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
    validationRequiredStatus: getValidationRequiredStatus(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsPatientEvents))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsPatientEvents/SettingsPatientEvents.js